import { Fragment } from 'react';

import { type IconName, Separator, VStack } from '@betterment/samba-react';

import { TaskCategory } from '~/graphql/schema';

import { TaskListRow } from '../components/TaskListRow';

const CATEGORY_ICON: Record<TaskCategory, IconName> = {
  [TaskCategory.Compliance]: 'SecurityCheck',
  [TaskCategory.Employees]: 'People',
  [TaskCategory.Onboarding]: 'Map',
  [TaskCategory.Payroll]: 'JointCash',
  [TaskCategory.Plan]: 'Briefcase',
  [TaskCategory.Reports]: 'Bar',
};

const getCategoryIcon = (category: TaskCategory): IconName => CATEGORY_ICON[category] ?? 'CheckmarkCircle';

type Task = {
  type: string;
  route: string;
  category: TaskCategory;
  count: number;
  countDescription?: string | null;
  description: string;
  progressPercentage?: number | null;
  progressDescription?: string | null;
  dateDescription?: string | null;
};

type Props = {
  tasks: Task[];
};

export const TaskList = ({ tasks }: Props) => {
  if (tasks.length === 0) {
    return null;
  }

  return (
    <VStack>
      {tasks.map((task, index) => (
        <Fragment key={task.type}>
          {index > 0 && <Separator css={{ fullWidthWithInset: 'space.300' }} />}
          <TaskListRow to={task.route}>
            <TaskListRow.Icon name={getCategoryIcon(task.category)} />
            <TaskListRow.Description
              detail={task.countDescription != null ? `${task.count} ${task.countDescription}` : undefined}
            >
              {task.description}
            </TaskListRow.Description>
            {(task.progressPercentage != null || task.dateDescription != null) && (
              <TaskListRow.Progress
                value={task.progressPercentage}
                description={task.progressDescription}
                dateDescription={task.dateDescription}
              />
            )}
          </TaskListRow>
        </Fragment>
      ))}
    </VStack>
  );
};
